

import React from 'react';
import { ChartWidget } from '../widgets';

interface ChartsSectionProps {
  chartData: any[];
  loading: boolean;
}

export function ChartsSection({ chartData, loading }: ChartsSectionProps) {
  if (!chartData || chartData.length === 0) {
    return (
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
        {['Revenue Trend', 'Monthly Comparison'].map((title) => (
          <div key={title} className="rounded-xl border border-stone-200 bg-white p-4 sm:p-6 flex flex-col items-center justify-center min-h-[200px] text-stone-400">
            <svg className="w-10 h-10 mb-3 opacity-30" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
            </svg>
            <p className="text-sm font-medium text-stone-500">{title}</p>
            <p className="text-xs mt-1">No chart data yet</p>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
      <ChartWidget
        title="Revenue Trend"
        subtitle="Monthly revenue, costs, and profit"
        type="line"
        data={chartData}
        dataKeys={[
          { key: 'Revenue', color: '#C9A84C', label: 'Revenue' },
          { key: 'Cost', color: '#EF4444', label: 'Cost' },
          { key: 'Profit', color: '#10B981', label: 'Profit' },
        ]}
        loading={loading}
        height={300}
      />

      <ChartWidget
        title="Monthly Comparison"
        subtitle="Revenue vs Expenses"
        type="bar"
        data={chartData}
        dataKeys={[
          { key: 'Revenue', color: '#C9A84C', label: 'Revenue' },
          { key: 'Cost', color: '#EF4444', label: 'Cost' },
        ]}
        loading={loading}
        height={300}
      />
    </div>
  );
}
